import ApiService from "../api.service";

export default {
  getHome() {
    return ApiService.get("about/home/", "", 0);
  },
  getHistory() {
    return ApiService.get("about/history/", "", 0);
  },
  getSMM() {
    return ApiService.get("about/smm/", "", 0);
  },
  getQuotes() {
    return ApiService.get("about/quotes/", "", 0);
  },
  getMainGallery() {
    return ApiService.get("about/album/main/", "", 0);
  },
  getGallery(id) {
    return ApiService.get(`about/album/${id}/`, "", 0);
  },
  getGraduates() {
    return ApiService.get("about/graduates/", "", 0);
  },
  getLstc() {
    return ApiService.get("lstc/list/", "", 0);
  },
  getLessons(filters = {}) {
    let filterString = "";
    Object.entries(filters).forEach(([key, value]) => {
      if (value.isArray) {
        value = value.join();
      }
      filterString += `&${key}=${value}`;
    });
    return ApiService.get("schedule", `?${filterString}`, 30);
  },
  getCourses() {
    return ApiService.get("schedule/courses/", "", 1440);
  },
  getTeachers() {
    return ApiService.get("schedule/teachers/", "", 0);
  },
  getFooterContacts() {
    return ApiService.get("schedule/teachers/footer/", "", 0);
  },
  getTeacherTypes() {
    return ApiService.get("schedule/teachers/types/", "", 1440);
  },
  getGratitude() {
    return ApiService.get("gratitude/", "", 0);
  },
  getContacts() {
    return ApiService.get("contacts/", "", 0);
  }
};
